module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.school_membership || _vm.individual_membership) ? _c('div', {
    staticClass: "mb-7"
  }, [(_vm.individual_membership) ? _c('div', {
    staticClass: "bg-gray-50 border border-solid border-gray-200 w-full rounded flex items-center px-6 py-4"
  }, [_c('div', {
    staticClass: "w-full"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center mb-3"
  }, [_c('div', {
    staticClass: "font-medium text-gray-800 font-poppins text-sm"
  }, [(!_vm.individual_membership.is_cancelled && _vm.individual_membership.stripe) ? _c('p', [_vm._v("\n              Your license will auto-renew on "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(_vm.individual_membership.expiry_date))])]) : _c('p', [_vm._v("\n              Your license will expire on "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(_vm.individual_membership.expiry_date))])])])]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), (!_vm.individual_membership.is_cancelled && _vm.individual_membership.stripe) ? _c('div', [_c('button', {
    staticClass: "bg-pinky text-white rounded px-5 font-semibold h-10 w-64 py-2",
    on: {
      "click": function($event) {
        return _vm.handleOpenModalUnsubscribe()
      }
    }
  }, [_vm._v("\n          Cancel Subscription\n        ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.school_membership) ? _c('div', {
    staticClass: "bg-coolGray-100 w-full rounded flex items-center px-6 py-3",
    class: [_vm.school_membership && _vm.individual_membership ? 'mt-3' : '']
  }, [_c('div', {
    staticClass: "w-full"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "flex justify-between items-center mb-3"
  }, [_c('div', [_c('span', [_vm._v(_vm._s(_vm.school_membership.school_name))]), _vm._v(" "), _c('span', {
    staticClass: "text-gray-800 text-sm font-poppins"
  }, [_vm._v("\n              Your license expires on "), _c('span', {
    staticClass: "font-semibold"
  }, [_vm._v(_vm._s(_vm.school_membership.expiry_date))])])])]), _vm._v(" "), _vm._m(3)])]) : _vm._e()]) : _c('div', {
    staticClass: "mb-6"
  }, [_vm._m(4)]), _vm._v(" "), _c('div', {
    staticClass: "grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 w-full xl:w-7/12 gap-y-5 gap-x-5"
  }, [_c('div', {
    staticClass: "px-7 py-8 bg-gray-50 rounded border border-solid border-gray-200",
    class: _vm.individual_membership || _vm.school_membership ? 'bg-gray-50 bg-opacity-50' : ''
  }, [_vm._m(5), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center"
  }, [_c('button', {
    staticClass: "bg-pinky rounded px-5 py-2 text-white font-semibold w-full",
    class: _vm.individual_membership || _vm.school_membership ? 'bg-pinky cursor-default bg-opacity-50' : '',
    attrs: {
      "disabled": _vm.individual_membership || _vm.school_membership
    },
    on: {
      "click": _vm.subscribe
    }
  }, [_vm._v("\n          Upgrade Now\n        ")])])]), _vm._v(" "), _c('div', {
    staticClass: "px-7 py-8 bg-gray-50 border border-solid border-gray-200 rounded relative",
    class: _vm.individual_membership || _vm.school_membership ? 'bg-gray-50 bg-opacity-50' : ''
  }, [_c('h4', {
    staticClass: "font-poppins text-center font-semibold text-gray-800 text-lg mb-6"
  }, [_vm._v("\n        School License\n      ")]), _vm._v(" "), _vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.school_code),
      expression: "school_code"
    }],
    staticClass: "mb-14 bg-white focus:border-pinky disabled:opacity-50 text-gray-500 outline-none flex-grow px-3 py-2 w-full rounded placeholder-gray-300 border border-gray-300",
    attrs: {
      "placeholder": "School Code",
      "disabled": _vm.individual_membership || _vm.school_membership,
      "errorMessage": _vm.error_message
    },
    domProps: {
      "value": (_vm.school_code)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.school_code = $event.target.value
      }, function($event) {
        _vm.error_message = ''
      }]
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "absolute bottom-8 w-full"
  }, [_c('button', {
    staticClass: "bg-pinky rounded px-5 py-2 text-white font-semibold",
    class: _vm.individual_membership || _vm.school_membership ? 'bg-pinky cursor-default bg-opacity-50' : '',
    staticStyle: {
      "width": "calc(100% - 56px)"
    },
    attrs: {
      "disabled": _vm.individual_membership || _vm.school_membership
    },
    on: {
      "click": _vm.submitCode
    }
  }, [_vm._v("\n          Upgrade Now\n        ")])])])]), _vm._v(" "), (_vm.isModalUnsubscribeOpen === true) ? _c('ConfirmUnsubscribeModal', {
    attrs: {
      "dateFinishSubscription": _vm.individual_membership.expiry_date
    },
    on: {
      "close": function($event) {
        _vm.isModalUnsubscribeOpen = false
      }
    }
  }) : _vm._e()], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xl font-poppins text-gray-800"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("You have a Teacher License")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-gray-600 w-full"
  }, [_vm._v("\n          Learn more about Parlay's\n          "), _c('a', {
    staticClass: "text-pinky hover:underline cursor-pointer",
    attrs: {
      "href": "https://parlayideas.com/schools-districts/",
      "target": "_blank"
    }
  }, [_vm._v("\n            memberships and pricing options\n          ")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-xl font-poppins text-gray-800"
  }, [_c('span', {
    staticClass: "font-semibold"
  }, [_vm._v("You have a School License")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-gray-600 w-full"
  }, [_vm._v("\n          Learn more about Parlay's\n          "), _c('a', {
    staticClass: "text-pinky hover:underline cursor-pointer",
    attrs: {
      "href": "https://parlayideas.com/schools-districts/",
      "target": "_blank"
    }
  }, [_vm._v("\n            memberships and pricing options\n          ")]), _vm._v(".\n        ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "w-full bg-gray-50 font-poppins border border-solid border-gray-200 rounded px-6 py-4"
  }, [_c('div', {
    staticClass: "text-xl mb-1"
  }, [_c('span', {
    staticClass: "font-semibold text-gray-800"
  }, [_vm._v("You have a Free Teacher Account")])]), _vm._v(" "), _c('div', {
    staticClass: "text-gray-600 w-full"
  }, [_vm._v("\n        Learn more about Parlay's\n        "), _c('a', {
    staticClass: "text-pinky hover:underline cursor-pointer",
    attrs: {
      "href": "https://parlayideas.com/schools-districts/",
      "target": "_blank"
    }
  }, [_vm._v("\n          memberships and pricing options\n        ")]), _vm._v(".\n      ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "flex flex-col flex-grow"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('h4', {
    staticClass: "text-center font-poppins font-semibold text-gray-800 text-lg mb-6"
  }, [_vm._v("\n            Teacher License\n          ")]), _vm._v(" "), _c('span', {
    staticClass: "text-center font-poppins font-light"
  }, [_vm._v("\n            Everything in your free account plus...\n          ")])]), _vm._v(" "), _c('div', [_c('ul', {
    staticClass: "list-decimal ml-5"
  }, [_c('li', [_vm._v("Unlimited RoundTables")]), _vm._v(" "), _c('li', [_vm._v("RoundTable Data Export")]), _vm._v(" "), _c('li', [_vm._v("Student Reports")]), _vm._v(" "), _c('li', [_vm._v("Co-Teachers")]), _vm._v(" "), _c('li', [_vm._v("Saved Feedback Templates")]), _vm._v(" "), _c('li', [_vm._v("Verbal RoundTable Video")])])]), _vm._v(" "), _c('div', {
    staticClass: "my-6 flex justify-center"
  }, [_c('span', {
    staticClass: "text-3xl font-poppins font-bold"
  }, [_vm._v("$120")]), _vm._v(" "), _c('span', {
    staticClass: "font-medium flex items-end font-poppins mb-1 ml-1"
  }, [_vm._v("per year")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "px-3 text-center"
  }, [_c('p', [_vm._v("\n          If your school or district has a license, enter the code below to\n          upgrade your account.\n        ")]), _vm._v(" "), _c('p', {
    staticClass: "my-6"
  }, [_vm._v("\n          If you don't know your school code, reach out to us in the chat and\n          we'll provide it for you.\n        ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-3cffcf5b!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/profile/profileTabs/membershipTab.vue
// module id = 1618
// module chunks = 61